import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, ShieldCheckIcon, CrownIcon } from 'lucide-react';
export function BrandPositioning() {
  const values = [{
    title: 'Personalized Treatments',
    description: 'Every treatment plan is customized to your goals, features, and comfort level.',
    icon: SparklesIcon
  }, {
    title: 'Licensed Professionals',
    description: 'Our team focuses on safe, thoughtful, and refined aesthetic care.',
    icon: ShieldCheckIcon
  }, {
    title: 'Luxury Experience',
    description: 'From consultation to treatment, every detail is designed to feel elevated and welcoming.',
    icon: CrownIcon
  }];
  return <section className="py-20 bg-brand-black relative z-10" data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-105">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-106">
          {values.map((value, index) => <motion.div key={value.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-brand-charcoal border border-brand-gold/20 p-8 rounded-sm hover:border-brand-gold/40 transition-colors duration-300 group" data-id="element-107">
              <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center mb-6 group-hover:bg-brand-gold/20 transition-colors duration-300" data-id="element-108">
                <value.icon className="w-6 h-6 text-brand-gold" strokeWidth={1.5} data-id="element-109" />
              </div>
              <h3 className="font-heading text-xl text-brand-white mb-3" data-id="element-110">
                {value.title}
              </h3>
              <p className="text-brand-champagne-light/70 text-sm leading-relaxed" data-id="element-111">
                {value.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}